import { callApi } from '../../../../apiCaller';
import { toastError } from '../../../../utils';
import { setIsLoading } from '../../../../actions/general';

export const SET_SUBSCRIBER_PRODUCTS = 'setSubscriberProducts';
export const SET_SUBSCRIBER_PRODUCT_DETAIL = 'setSubscriberProductDetail';

export const API_GUEST_SUBSCRIBER_PRODUCT = 'products';
export const API_GUEST_SUBSCRIBER_PRODUCT_DETAIL = 'products/product/:slug';
export const API_GUEST_SUBSCRIBER_PRODUCT_DETAIL_BY_ID = 'products/:id';

export const setSubscriberProductDetail = (product) => {
     return {
          type: SET_SUBSCRIBER_PRODUCT_DETAIL,
          payload: product,
     };
};

export const setSubscriberProducts = (products) => {
     return {
          type: SET_SUBSCRIBER_PRODUCTS,
          payload: products,
     };
};

export const fetchSubscriberProductsRequest = () => async (dispatch) => {
     dispatch(setIsLoading(true));

     return await callApi(API_GUEST_SUBSCRIBER_PRODUCT, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(setSubscriberProducts(response.data));
               return response.data;
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};

export const fetchSubscriberProductDetailRequest = (slug) => (dispatch, getState) => {
     const product = getState().subscriber.products.current;

     if (!product || product?.slug !== slug) {
          dispatch(setIsLoading(true));
          callApi(API_GUEST_SUBSCRIBER_PRODUCT_DETAIL.replace(':slug', slug), 'GET')
               .then((response) => {
                    if (response.status === 200) {
                         dispatch(setSubscriberProductDetail(response.data));
                    } else {
                         toastError(response);
                    }
               })
               .finally(() => {
                    dispatch(setIsLoading(false));
               });
     }
};
